import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const categoryColors: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-white',
    accent: 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-white',
    secondary: 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-white',
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-4">
            探索你感兴趣的内容
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto leading-relaxed">
            六大内容板块，覆盖交友、生活、权益、故事、活动和健康
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/categories?cat=${category.slug}`}
              className="group flex items-start gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-lg shrink-0 transition-all duration-300 ${
                  categoryColors[category.color] || categoryColors.primary
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-foreground-900 mb-1 font-heading whitespace-nowrap">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                  {category.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {category.articleCount} 篇文章
                </span>
              </div>
              <div className="w-6 h-6 flex items-center justify-center shrink-0 self-center text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-1 transition-all duration-200">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}